import {
  Widget,
  WidgetFC,
  WidgetMap,
  WidgetProps
} from 'index.d'
import {
  WidgetMapPropType,
  WidgetPropType
} from 'index.pt'
import _ from 'lodash'
import PT from 'prop-types'
import React from 'react'

export interface WidgetEditOptionsProps {
  myWidgets: WidgetMap<any>;
  widget: Widget;
  onUpdate: (w: Widget) => void;
}

const WidgetEditOptions: React.FC<WidgetEditOptionsProps> = (props: WidgetEditOptionsProps): JSX.Element => {
  const { myWidgets, widget } = props

  const FoundWidget: WidgetFC<WidgetProps> | undefined = _.find(_.values(myWidgets), (it) => {
    return it.properties ? it.properties.type === widget.type : false
  })

  if (FoundWidget && FoundWidget.Edit) {
    return <FoundWidget.Edit {...props} />
  }
  return <div />
}

WidgetEditOptions.propTypes = {
  myWidgets: WidgetMapPropType.isRequired,
  widget: WidgetPropType.isRequired,
  onUpdate: PT.func.isRequired
}

export default WidgetEditOptions
